// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + ".chunk." + {"88":"cc77d4a4","655":"bcdf0d48","663":"3390e8af","790":"3375b744","943":"31672c30"}[chunkId] + ".js";
};